export default __webpack_public_path__ + "static/media/GoodFiction.b7031087.png";